import * as _ from 'underscore';

export class DisplayUtils {
  static displayFormattedNumberValue(value: number): string {
    return _.isNumber(value)
      ? value.toLocaleString('tr-TR', {
          maximumFractionDigits: 2,
        })
      : '-';
  }

  static displayRawValue(value: any): string {
    return _.isNull(value) || _.isUndefined(value) ? '-' : value;
  }

  static displayTextValue(value: any): string {
    return _.isString(value) ? value : '-';
  }

  static displayPercentageValue(value: number): string {
    return _.isNumber(value) ? '%' + value.toFixed(2) : '-';
  }
}
